import React, { useEffect, useState } from "react";
import { useTranslation  } from "react-i18next";
import { connect } from "react-redux";
import { SzButton, SzModal } from "@suezenv/react-theme-components";
import { bindActionCreators } from "redux";
import { Authenticate } from "../../services/Authenticate";
import { ErrorActions } from "../../store/actions";
import "./errorMessage.scss";

const ErrorAuthenticationMessage = (props: any) => {
  const { t } = useTranslation();
  const [show, isShow] = useState(false);

  useEffect(() => {
    isShow(props.show);
  }, [props]);

  const handleClose = () => {
    Authenticate.logout(props.ssoToken);
  };

  const handleClick = () => {
    Authenticate.logout(props.ssoToken);
  };

  return (
    <>
      {/* set translate default value in case provider not loaded (problem on firefox)*/}
      <SzModal title={t("error.sessionExpired", "Votre session a expiré")} show={show} handleClose={handleClose} size={"xl"}>
        <p className="text-center">{t("error.connectMesssage", "Veuillez vous reconnecter")}</p>
        <div className="mt-1 m-auto">
          <div className="row justify-content-center">
            <SzButton className="col-9 col-md-3 m-0" onClick={handleClick}>
              {t("error.connectButton", "JE ME RECONNECTE")}
            </SzButton>
          </div>
        </div>
      </SzModal>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  ...bindActionCreators({...ErrorActions}, dispatch),
});

const mapStateToProps = (state: any) => {
  return {
    ssoToken: state.user.ssoToken,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorAuthenticationMessage);
